import React from 'react';
import { useParams } from 'react-router-dom';
import { IGroup } from 'src/utilities/useSearchHooks';
import { DataTable } from 'src/components/DataTable';
import { createSearchAdapter } from 'src/components/DataTable/adapters/useSearchAdapter';
import { SortDirection } from 'src/components/DataTable/types/DataTable';
import { createEmployeeGroupsSelectionAdapter } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/components/EmployeeGroupsWrapper/hooks/createEmployeeGroupsSelectionAdapter';

export const EmployeeGroupsWrapper: React.FC = () => {
  const { corpid: corpId, employeeId } = useParams<{
    corpid: string;
    employeeId: string;
  }>();

  const useTableAdapter = createSearchAdapter<IGroup>({
    searchUrl: `/corps/${corpId}/tags/search`,
  });

  const useSelectionAdapter = createEmployeeGroupsSelectionAdapter({
    corpId,
    employeeId,
  });

  return (
    <DataTable.Provider
      adapter={useTableAdapter}
      initialState={{
        sortField: 'NAME',
        sortOrder: SortDirection.ASC,
      }}
    >
      <DataTable.SelectionProvider
        adapter={useSelectionAdapter}
        entityName="group"
        hideSelectionMessage
        primaryActionName="Update Group"
        secondaryActionName="Cancel"
      >
        <DataTable.Container>
          <DataTable.TitleBar>
            <DataTable.Title x="sm">Groups</DataTable.Title>
            <DataTable.Summary />
          </DataTable.TitleBar>
          <DataTable.Toolbar justifyContent="space-between">
            <DataTable.Search placeholder="Group name" />
            <DataTable.ButtonLink
              href={`/corporate/enterprise/${corpId}/groups/create`}
            >
              Add New Group
            </DataTable.ButtonLink>
          </DataTable.Toolbar>
          <DataTable.Content>
            <DataTable.Header>
              <DataTable.Column phone={1} />
              <DataTable.Column phone={4}>Name</DataTable.Column>
              <DataTable.Column phone={5}>Description</DataTable.Column>
            </DataTable.Header>
            <DataTable.Body>
              {(group: IGroup): JSX.Element => (
                <DataTable.Row key={group.id} id={group.id}>
                  <DataTable.SelectableCell id={group.id} phone={1} />
                  <DataTable.Cell phone={4}>{group.name}</DataTable.Cell>
                  <DataTable.Cell phone={5}>{group.description}</DataTable.Cell>
                  <DataTable.Cell phone={2} justifyContent="flex-end">
                    <DataTable.Link
                      href={`/corporate/enterprise/${corpId}/groups/${group.id}/details`}
                    >
                      View
                    </DataTable.Link>
                  </DataTable.Cell>
                </DataTable.Row>
              )}
            </DataTable.Body>
            <DataTable.Footer>
              <DataTable.Pagination />
            </DataTable.Footer>
          </DataTable.Content>
        </DataTable.Container>
      </DataTable.SelectionProvider>
    </DataTable.Provider>
  );
};
